<template>
  <v-card v-if="loading" class="pa-16">
    <h2 class="text-center">
      <v-progress-circular
        indeterminate
        color="primary"
        class="mr-2"
      ></v-progress-circular
      >Loading...
    </h2>
  </v-card>
  <v-card v-else class="pa-4 primary darken-2" >
    <v-row>
      <v-col cols="5" class="ml-12">
        <v-card class="flexcard pa-4" height="100%" light>
          <h3 align="right">
            Total active health workers:

            {{ totalWorkers ? totalWorkers : 0 }}
            <v-icon left large color="blue">
              mdi-account-circle-outline
            </v-icon>
          </h3>
          <br />
          <h4 align="right">
            Male:

            {{ genderData.male ? genderData.male : 0 }}
            <v-icon left large color="purple lighten-1">
              mdi-human-male
            </v-icon>
          </h4>
          <br />
          <h4 align="right">
            Female:

            {{ genderData.female ? genderData.female : 0 }}
            <v-icon left large color="pink"> mdi-human-female </v-icon>
          </h4>
        </v-card>
      </v-col>

      <v-col cols="6" class="flexcard"  >
        <v-card light>
          <apexchart
            ref="workersChart"
            :options="workersChart"
            :series="workersSeries"
            type="donut"
            width="400"
          ></apexchart>
        </v-card>
      </v-col>


    </v-row>

    <br />
    <v-divider></v-divider>
    <v-row>
      <v-col class="mt-8 ml-12" cols="5">
        <v-card light>
          <h3>Educational Data details</h3>
          <apexchart
            ref="educationalChart"
            :options="educationalOption"
            :series="edSeries"
            type="polarArea"
            width="400"
          ></apexchart>
        </v-card>
      </v-col>
        <v-col class="mt-8" cols="6 ">
        <v-card class="flexcard" height="100%" light>
          <h3 align="left" class="ml-4">
            Data filled in for salary info
            <v-icon left large> mdi-account-circle-outline </v-icon>
          </h3>
          <v-container class="pa-4 mt-4">
            <v-progress-linear :value="salary.filled" height="25" style="border-radius:25px">
              <strong>{{ Math.ceil(salary.filled) }} </strong>&nbsp;filled
            </v-progress-linear>
            <br />
            <v-progress-linear :value="salary.notfilled" height="25" style="border-radius:25px">
              <strong>{{ Math.ceil(salary.notfilled) }}</strong> &nbsp;not
              filled<br />
            </v-progress-linear>
          </v-container>
        </v-card>
      </v-col>  
    </v-row>
  </v-card>
</template>

<script>
import axios from "axios";
import "../plugins/chart";

export default {
  name: "FacilityInformation",
  props: ["id", "name", "partOf", "closed"],
  data: function () {
    return {
      loading: true,
      totalWorkers: 0,
      workersSeries: [],
      salary: {},
      genderData: {},
      workersChart: {
        title: {
          text: "Workers Status",
          align: "center",
          style: {
            fontSize: "18px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },

        colors: ["#F44336", "#48FF00"],
        labels: ["In-Active", "Active"],
        chart: {
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 90,
            offsetY: 10,
          },
        },
        grid: {
          padding: {
            bottom: -80,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      educationalOption: {
        chart: {
          type: "polarArea",
        },
        stroke: {
          colors: ["#fff"],
        },
        fill: {
          opacity: 0.8,
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      edSeries: [],

  
    };
  },
  created: function () {
    this.setupData();
  },
  watch: {
    id: function () {
      this.setupData();
    },
    partOf: function () {
      this.loading = true;
      this.setupData();
    },
    closed: function () {
      if (this.closed === false) {
        this.response = undefined;
        this.id = undefined;
      } else {
        this.response = undefined;

        this.setupData();
      }
    },
  },
  methods: {
    setupData() {
      this.totalWorkers = 0;
      this.workersSeries = [];
      this.salary = {
        filled: 0,
        notfilled: 0,
      };
      this.genderData = {};
      this.edSeries = [];
      this.professionData = [];
      this.professionSeries = [];
      this.loading = true;
      this.educationalOption.labels = [];
   
      axios
        .post(`/report/facility/getAllInfo`, {
          id: this.id,
          partOf: this.partOf,
        })
        .then((res) => {
         
          this.totalWorkers = res.data.workers.active
          this.workersSeries = [
            res.data.workers.inactive,
            res.data.workers.active,
          ];
          this.salary = res.data.salary;

          let tmp = [Object.keys(res.data.educationData)];
          let tmp2 = [Object.values(res.data.educationData)];
          this.edSeries = tmp2[0];
          this.educationalOption.labels = tmp[0];
          this.genderData = res.data.genderData;
          this.professionSeries = [
            res.data.professionCategory.academic,
            res.data.professionCategory.professional,
            res.data.professionCategory.adminstrative,
          ];

          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>